export default __webpack_public_path__ + "static/media/airdockz-wht-banner-3.9fe03170.jpg";